import React from 'react';
import styled from 'styled-components';
import LogoIcon from './LogoIcon';
import LogoText from './LogoText';
import Spacer from './Spacer';

const Container = styled.div`
  padding: 20px;
  border-top: 1px solid #ecedf7;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  font-size: 14px;
  color: #9092aa;
  width: 100%;
  background: white;
`;

const Link = styled.a`
  margin: 0px 35px;
  color: #8f93aa;
  text-decoration: none;
  font-weight: 400;
  font-size: 13px;
  &:hover {
    color: #171d3c;
  }
`;

function Footer() {
  return (
    <Container>
      <Link
        href={'https://docs.paypi.dev/legal/terms-and-conditions'}
        target='_blank'
      >
        Terms
      </Link>
      <Spacer horizontal spacing={3} />
      <LogoIcon height={'14px'} color={'#9092aa'} />
      <LogoText color={'#9092aa'} height={'16px'} />
      <Spacer horizontal spacing={3} />
      <Link href='https://docs.paypi.dev/legal/privacy-policy' target='_blank'>
        Privacy Policy
      </Link>
    </Container>
  );
}

export default Footer;
